import { render } from "./App.vue?vue&type=template&id=7485e810&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7485e810&scoped=true&lang=css"

import exportComponent from "/home/sysadmin/shared-platform-web-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7485e810"]])

export default __exports__